import React from "react";

function Footer() {
    return (
        <footer>
            <div className="custom-shape-divider-bottom-1656519457">
            </div>
            <div className="footer-inner">
                <div className="container">
                    Copyright 2024. Web Developer Portfolio__by Park TaeEun
                </div>
            </div>
        </footer>
    );
}
export default Footer;